export default "__VITE_ASSET__8jcJ5yP6__"